export default __webpack_public_path__ + "static/media/aboutcurrent.163f6e77.webp";